import dayjs from 'dayjs';
import { CalendarIcon } from 'lucide-react';
import { useState } from 'react';

import { cn } from 'lib/utils';

import { Button } from './ui/button';
import Calendar from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

type Props = {
  value: string | null;
  selectFn: (date: string) => void;
  placeholder: string;
  width?: string;
};

function DatePopoverSingle({
  placeholder,
  selectFn,
  value,
  width = 'w-full',
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          size="sm"
          variant="outline"
          className={cn(
            'justify-start text-left font-normal',
            width,
            !value && 'text-muted-foreground',
          )}
        >
          <CalendarIcon className="ml-4 h-5 w-5" />
          {value ? (
            dayjs(value).format('DD, MMMM, YYYY')
          ) : (
            <span>{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto rounded-3xl p-0">
        <Calendar
          selectedDate={value ? new Date(value) : null}
          onDateSelect={(date: Date) => {
            selectFn(dayjs(date).format('YYYY-MM-DD'));
            setIsOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}

export default DatePopoverSingle;
